const firebaseConfig = {

  apiKey: "AIzaSyCXtwAlA2Ag1Zi86pjWIzkaf_PTXf_QwRk",

  authDomain: "body-burn-5d754.firebaseapp.com",

  projectId: "body-burn-5d754",

  storageBucket: "body-burn-5d754.appspot.com",

  messagingSenderId: "684983100634",

  appId: "1:684983100634:web:f28dab9fa2fb5c723af1e3"

};


  export default firebaseConfig;